import { post } from "@selector/shared";
import type { components } from "@selector/shared/openapi";

export async function getFeatureRowIndex(requestBody: components["schemas"]["TableRequest"], featureId: number) {
  const { data } = await post("/featureRowId", undefined, { featureId }, requestBody);
  return data;
}
